import React from 'react';
import DefaultFooter from '../components/DefaultFooter';
import ShopBarbers from '../components/ShopBarbers';
import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';
import { red, grey } from '@mui/material/colors';

import Details from '../components/Details';

import { Grid, Container } from '@mui/material';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? red[500] : grey[200],
  ...theme.typography.body2,
  padding: theme.spacing(1),
  margin: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const ShopBarber = () => {
  return (
    <Container
      sx={{
        marginBottom: '30px',
        marginTop: '30px',
        width: '100%',
        padding: '0 !important',
        height: 'auto',
      }}
    >
      <Grid
        container
        spacing={3}
        sx={{
          marginTop: 0,
          marginBottom: 10,
          padding: 0,
        }}
      >
        <Grid className="displayed-order" item xs={12} md={3} lg={3}>
          <Item
            sx={{
              backgroundColor: 'white',
              margin: '0 !important',
              border: '0',
              padding: '0',
            }}
          >
            <Details />
          </Item>
        </Grid>
        <Grid className="changed-order" item xs={12} md={9} lg={9}>
          <Item
            sx={{
              backgroundColor: 'white',
              margin: '0',
              border: '0',
              padding: '0',
            }}
          >
            <ShopBarbers />
          </Item>
        </Grid>
      </Grid>
      <DefaultFooter />
    </Container>
  );
};

export default ShopBarber;
